import { Skeleton, StatBlock, EmptyState } from "@cntrl/ui";
import { Modal } from "../../releases/Modal.js";
import { useCapability } from "../../../app/bandContext.js";
import { useBroadcastStats } from "../../../app/hooks/useBroadcasts.js";
import styles from "./FanForm.module.scss";

/**
 * Per-broadcast delivery/engagement stats — a routed modal (`/marketing/fans/broadcasts/$broadcastId`),
 * deep-linkable. v1 is LOG-ONLY, so every counter is 0 (nothing sent); the modal says so plainly rather
 * than implying a delivery happened.
 */
export function BroadcastStatsModal({ broadcastId, onClose }: { broadcastId: string; onClose: () => void }) {
  const canRead = useCapability("fans:read");
  const q = useBroadcastStats(canRead ? broadcastId : undefined);

  if (!canRead) return null;   // deep-link guard (the API also 403s the fan-PII surface)

  return (
    <Modal title="Broadcast stats" size="md" onClose={onClose}>
      {q.isLoading || !q.data ? (
        q.isError ? (
          <EmptyState title="Couldn't load stats" description="Something went wrong." />
        ) : (
          <div role="status" aria-label="Loading"><Skeleton variant="line" width="70%" /></div>
        )
      ) : (
        <div className={styles.form}>
          <p className={styles.banner}>
            This broadcast was <strong>logged</strong>, not sent — delivery stats populate once email &amp; SMS sending ships.
          </p>
          <div className={styles.statsGrid}>
            <StatBlock label="Recipients" value={q.data.recipients} />
            <StatBlock label="Sent" value={q.data.sent} />
            <StatBlock label="Delivered" value={q.data.delivered} />
            <StatBlock label="Opened" value={q.data.opened} />
            <StatBlock label="Clicked" value={q.data.clicked} />
            <StatBlock label="Bounced" value={q.data.bounced} />
          </div>
        </div>
      )}
    </Modal>
  );
}
